
export const fetchDataRequest = (type, data = null) => ({ type, payload: data });
export const fetchDataSuccess = (type, data) => ({ type, payload: data });
export const fetchDataFailure = (type, error) => ({ type, payload: error });